/**
 * @module olgm/layer/Google
 */
import TileLayer from 'ol/layer/Tile.js';

/**
 * @typedef {Object} Options
 * @property {boolean} [visible=true] Visibility.
 * @property {google.maps.MapTypeId<(number|string)>|string|undefined} [mapTypeId=google.maps.MapTypeId.ROADMAP] The type of google map
 * @property {Array<google.maps.MapTypeStyle>|undefined} [styles] Google map styling
 */

/**
 * @classdesc
 * An ol3 layer object serving the purpose of being added to the ol3 map
 * as dummy layer. The `mapTypeId` defines which Google Maps map type the
 * layer represents.
 * @api
 */
var GoogleLayer = (function (TileLayer) {
  function GoogleLayer(opt_options) {
    var options = opt_options ? opt_options : {};
    TileLayer.call(this, options);

    /**
     * @type {google.maps.MapTypeId<(number|string)>|string}
     * @private
     */
    this.mapTypeId_ = options.mapTypeId !== undefined ? options.mapTypeId :
      google.maps.MapTypeId.ROADMAP;

    /**
     * @type {?Array<google.maps.MapTypeStyle>}
     * @private
     */
    this.styles_ = options.styles ? options.styles : null;
  }

  if ( TileLayer ) GoogleLayer.__proto__ = TileLayer;
  GoogleLayer.prototype = Object.create( TileLayer && TileLayer.prototype );
  GoogleLayer.prototype.constructor = GoogleLayer;


  /**
   * @return {google.maps.MapTypeId<(number|string)>|string} map type id
   * @api
   */
  GoogleLayer.prototype.getMapTypeId = function getMapTypeId () {
    return this.mapTypeId_;
  };


  /**
   * @return {?Array<google.maps.MapTypeStyle>} map styles
   */
  GoogleLayer.prototype.getStyles = function getStyles () {
    return this.styles_;
  };

  return GoogleLayer;
}(TileLayer));
export default GoogleLayer;

//# sourceMappingURL=Google.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@geosolutions/olgm/layer/Google.js
// module id = 215
// module chunks = 1